@if(alertBanner) {
    @if (!dismissible || (dismissible && !dismissed)) {
    <div
        class="davesa-alert-banner-container"
        [@fadeIn]="!dismissed"
        [@fadeOut]="!dismissed"
    >
        <!-- Border -->
        @if (appearance === 'border') {
            <div class="davesa-alert-banner-border"></div>
        }

        <!-- Icon -->
        @if (showIcon) {
            <div class="davesa-alert-banner-icon">
                <!-- Custom icon -->
                <div class="davesa-alert-banner-custom-icon">
                    <ng-content select="[davesaAlertIcon]"></ng-content>
                </div>

                <!-- Default icons -->
                <div class="davesa-alert-banner-default-icon">
                    @if (type === 'primary') {
                        <mat-icon
                            [svgIcon]="'heroicons_solid:check-circle'"
                        ></mat-icon>
                    }

                    @if (type === 'accent') {
                        <mat-icon
                            [svgIcon]="'heroicons_solid:check-circle'"
                        ></mat-icon>
                    }

                    @if (type === 'warn') {
                        <mat-icon
                            [svgIcon]="'heroicons_solid:x-circle'"
                        ></mat-icon>
                    }

                    @if (type === 'basic') {
                        <mat-icon
                            [svgIcon]="'heroicons_solid:check-circle'"
                        ></mat-icon>
                    }

                    @if (type === 'info') {
                        <mat-icon
                            [svgIcon]="'heroicons_solid:information-circle'"
                        ></mat-icon>
                    }

                    @if (type === 'success') {
                        <mat-icon
                            [svgIcon]="'heroicons_solid:check-circle'"
                        ></mat-icon>
                    }

                    @if (type === 'warning') {
                        <mat-icon
                            [svgIcon]="'heroicons_solid:exclamation-triangle'"
                        ></mat-icon>
                    }

                    @if (type === 'error') {
                        <mat-icon
                            [svgIcon]="'heroicons_solid:x-circle'"
                        ></mat-icon>
                    }
                </div>
            </div>
        }

        <!-- Content -->
        <div class="davesa-alert-banner-content">
            <div class="davesa-alert-banner-title">
                <ng-content select="[davesaAlertTitle]"></ng-content>
            </div>

            <div class="davesa-alert-banner-message">
                <ng-content></ng-content>
            </div>
        </div>

        <!-- Dismiss button -->
        <button
            class="davesa-alert-banner-dismiss-button"
            mat-icon-button
            (click)="dismiss()"
        >
            <mat-icon [svgIcon]="'heroicons_solid:x-mark'"></mat-icon>
        </button>
    </div>
}
}